import styled from "styled-components";
import theme from "~/styles/theme";

export const BannerHolder = styled.section`
  position: relative;
  text-align: center;
  background: #b1dbf0;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-top: 75px;
  }
  div {
    padding: 0 16px;
    margin: -190px 0 0;
    background-color: #E398FF;
    padding: 0 12px;

    @media (min-width: ${theme.breakpoints.values.sm}px) {
      margin: -355px 0 0;
    }

    @media (min-width: 767px) {
      margin: -20px 0 0;
    }

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      margin: -65px 0 0;
    }

    span, strong {
      display: block;
      font-size: 10px;
      color: #6F1C8E;
      line-height: 13.5px;
    }

    span {
      font-weight: 500;
    }

    strong {

      @media (min-width: ${theme.breakpoints.values.md}px) {
        margin-left: 32%;
        margin-bottom: 10px;
      }
    }
  }

`;

export const BannerImage = styled.img`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto -3px;
`;
